import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { ToastrService } from "ngx-toastr";
import { Subject, take, takeUntil } from "rxjs";
import { ApiResponse } from "src/app/shareModule/models/common.model";
import { AuthServiceService } from "src/app/shareModule/services/auth-service.service";
import { CommonService } from "src/app/shareModule/services/common.service";
import { AppState } from "src/app/shareModule/states/app.state";
import { selectAllCommunityProductCategory } from "src/app/shareModule/states/community-product-category";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-member-shop-ads",
  templateUrl: "./member-shop-ads.component.html",
  styleUrls: ["./member-shop-ads.component.scss"],
})
export class MemberShopAdsComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild("AssignOption") AssignOptionModal: ElementRef;
  public editMode: boolean;
  public commonModal: any;
  public allAds: Array<any> = [];
  public categoriesList: Array<any> = [];
  public subRegionList: Array<any> = [];
  public selectedAds: any;
  public imageBase64: string | ArrayBuffer;
  public imgUrl = environment.ImageUrl;
  public form: FormGroup = new FormGroup({
    image: new FormControl(null, [Validators.required]),
    description: new FormControl("", [Validators.required]),
    price: new FormControl("", [Validators.required]),
    url: new FormControl("", [Validators.required]),
    category: new FormControl(""),
    subregion: new FormControl(""),
  });

  constructor(
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    public commonService: CommonService,
    private store: Store<AppState>,
  ) { }

  ngOnInit(): void {
    this._getAdsList();
    this._getAllMemberShopCategoriesList();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public openProductCharForAddEdit(model, selected: any = null) {
    if (selected) {
      this.editMode = true;
      this.selectedAds = selected;
      this.form.patchValue({
        image: selected?.image,
        description: selected?.description,
        price: selected?.price,
        url: selected?.url,
        category: selected?.category,
        subRegion: selected?.subRegion,
      });
    }
    this.commonModal = this.modalService.open(model, {
      size: "xs",
      backdrop: "static",
      windowClass: "suggestion",
    });
  }

  private _getAllMemberShopCategoriesList(): void {
    this.store
      .pipe(select(selectAllCommunityProductCategory))
      .subscribe((list: any) => {
        let response = structuredClone(list);
        let output = response.map((i) => {
          let output = i;
          output["checked"] = false;
          return output;
        });
        this.categoriesList = this.commonService.removeDuplicateAndCombineByProp(output, "name");
      });
  }

  public openModal(selectedArticle) {
    this.categoriesList = this.categoriesList.map((i: any) => {
      let output = i;
      output["checked"] = selectedArticle.category ? selectedArticle.category.includes(i.name ? i.name : "") : false;
      return output;
    });

    let selectedId = selectedArticle.subRegion ? selectedArticle.subRegion.split('|') : [];

    this.subRegionList = structuredClone(this.commonService.subRegionLists.map((j) => {
      let output = JSON.parse(JSON.stringify(j));
      output['checked'] = selectedId.includes(j.subRegionId.toString());
      return output;
    }));


    this.selectedAds = selectedArticle;
    this.commonModal = this.modalService.open(this.AssignOptionModal, { size: "sm", ariaLabelledBy: "modal-basic-title", backdrop: "static" });
  }

  assignArticles() {
    if (this.selectedAds) {
      let categoryStr = this.categoriesList
        .filter((i) => i.checked)
        .map((i) => i.name)
        .join("|");
      let subRegionStr = this.subRegionList
        .filter((i) => i.checked)
        .map((i) => i.subRegionId)
        .join("|");

      let formData = new FormData();
      formData.append("description", this.selectedAds.description);
      formData.append("price", this.selectedAds.price);
      formData.append("url", this.selectedAds.url);
      formData.append("id", this.selectedAds?.id);
      formData.append("category", categoryStr);
      formData.append("subRegion", subRegionStr);


      this.auth.addMemberShopAds(formData).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.commonModal.close();
        this._getAdsList();
      });
    } else {
      this.toastr.error("InValid Id!");
    }
  }

  private _getAdsList() {
    this.auth.getAllMemberShopAds()
      .pipe(takeUntil(this.destroy$), take(1))
      .subscribe({
        next: (resp: ApiResponse) => {
          this.allAds = resp.body.map(ad => ({
            ...ad,
            categoryList: ad.category && ad.category.includes('|') ? ad.category.split('|') : [ad.category],
            subRegionList: ad.subRegion && ad.subRegion.includes('|') ? ad.subRegion.split('|') : [ad.subRegion]
          }));
        }
      });
  }

  public saveAds(): void {
    if (this.form.valid) {
      let formData = new FormData();
      typeof this.form.get("image").value == "string" ? "" : formData.append("image", this.form.get("image").value);
      formData.append("description", this.form.get("description").value);
      formData.append("price", this.form.get("price").value);
      formData.append("url", this.form.get("url").value);
      if (this.selectedAds) {
        formData.append("id", this.selectedAds?.id);
      }
      this.auth.addMemberShopAds(formData).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.modalDismissAll();
        this._getAdsList();
      });
    } else {
      this.toastr.error("Form is Invalid fill ALL ");
    }
  }

  public modalDismissAll() {
    this.modalService.dismissAll();
    this.selectedAds = null;
  }

  public saveProductCharSelectedImage(event) {
    this.selectedAds ? (this.selectedAds.image = null) : "";
    let file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.imageBase64 = fileReader.result;
      this.form.get("image").setValue(file);
    };
    fileReader.readAsDataURL(file);
  }

  public deleteAds(id) {
    this.auth.deleteMemberShopAds(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getAdsList();
    });
  }
}
